import dayjs from 'utils/dayjs.ts';

export const getWeekdayName = (date: string) => {
    const str = dayjs(date).format('dddd')
    return  str.charAt(0).toUpperCase() + str.slice(1);
}